module.exports = __webpack_public_path__ + "9f3282f7320e65ec0e33ef55a0f26787.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/images/ch_grid_6.png
// module id = 131
// module chunks = 1